// Port of api/fuel/app/classes/insights/players/count.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

export default Segment.extend({
	name: 'count',
	requires: ['init'],
	types: [Constants.TYPE_USER],
	insight: ['count.band', 'count.sort', 'count.threshold'],
	detail: ['count'],
	run: function(type, owner, userIndex, detail, filter) {
		var data = {
			counts: [],
			players: [],
			total: 0
		}
		var threshold = (filter && filter['count.threshold'] !== undefined) ? parseInt(filter['count.threshold'], 10) : 3
		var currentValue = (filter && filter['count.band'] !== undefined) ? parseInt(filter['count.band'], 10) : 2
		var sorting = (filter && filter['count.sort']) ? filter['count.sort'] : 'total'
		var index = [2, 3, 4, 5, 6]
		var maxCount = 6
		var limit = detail ? 250 : 5

		for (var i = 0; i < index.length; i++) {
			var value = index[i]
			var players = (this._data.players || []).filter(function(player) {
				var keys = Object.keys(player.counts || {})
				if (!keys.length) return false
				if (value < maxCount) return keys.indexOf(String(value)) !== -1
				return Math.max.apply(null, keys.map(function(key) { return parseInt(key, 10) })) >= maxCount
			})

			if (currentValue === value) {
				var finalPlayers = players.map(function(player) {
					var item = Object.assign({}, player)
					if (value < maxCount) {
						item.countPlays = parseInt((item.counts || {})[value], 10) || 0
					} else {
						item.countPlays = 0
						Object.keys(item.counts || {}).forEach(function(key) {
							if (parseInt(key, 10) >= maxCount) item.countPlays += item.counts[key]
						})
					}
					item.playRatio = item.totalPlays ? Math.round((100 / item.totalPlays) * item.countPlays) : 0
					return item
				})

				if (sorting === 'ratio') {
					finalPlayers = finalPlayers.filter(function(player) {
						return player.countPlays >= threshold
					})
				}

				var sortField = (sorting === 'total') ? 'countPlays' : 'playRatio'
				finalPlayers = finalPlayers.slice().sort(function(a, b) {
					var av = parseFloat(a[sortField]) || 0
					var bv = parseFloat(b[sortField]) || 0
					if (av !== bv) return bv - av
					return String(a.slug || '').localeCompare(String(b.slug || ''))
				})
				data.total = finalPlayers.length
				if (finalPlayers.length > limit) finalPlayers = finalPlayers.slice(0, limit)

				for (var fp = 0; fp < finalPlayers.length; fp++) {
					data.players.push({
						id: parseInt(finalPlayers[fp].id, 10) || 0,
						key: finalPlayers[fp].slug,
						slug: finalPlayers[fp].slug,
						name: finalPlayers[fp].primaryName,
						username: finalPlayers[fp].username,
						count: finalPlayers[fp].countPlays,
						ratio: finalPlayers[fp].playRatio
					})
				}
			}

			var plays = Object.keys(this._data.plays || {}).map(function(key) {
				return this._data.plays[key]
			}.bind(this)).filter(function(play) {
				return (value === maxCount) ? play.pl >= value : play.pl === value
			})

			var playCount = 0
			var gameIndex = []
			for (var p = 0; p < plays.length; p++) {
				playCount += plays[p].c
				gameIndex.push(plays[p].g)
			}

			data.counts.push({
				value: value,
				name: (value === maxCount) ? (value + 'p+') : (value + 'p'),
				plays: playCount,
				games: Array.from(new Set(gameIndex)).length,
				players: players.length
			})
		}

		return {
			counts: data
		}
	}
})
